export default "__VITE_PUBLIC_ASSET__34b8eb25__"